import { render } from "./TheFinanceBankStatement.vue?vue&type=template&id=54139ec8&scoped=true&lang=true"
import script from "./TheFinanceBankStatement.vue?vue&type=script&lang=js"
export * from "./TheFinanceBankStatement.vue?vue&type=script&lang=js"

import "./TheFinanceBankStatement.vue?vue&type=style&index=0&id=54139ec8&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54139ec8"]])

export default __exports__